import { use_slice_workspace } from '@/hooks/store/use_slices';
import { md } from '@/utils/utils_html';
import { DTOWorkspaceCreditTransaction } from '@shared/dto/+workspace/workspace_credit_transaction/dto_workspace_credit_transaction';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { format_compact_number, format_number_with_spaces } from '@shared/utils/utils_number';
import { useState } from 'react';

interface Props {
  user: DTO__workspace_user;
  workspace_credits_all: DTOWorkspaceCreditTransaction[];
  workspace_credits_total: number;
  is_coins: boolean;
}

export const WSTableAllTimeCreditsCell: React.FC<Props> = ({ user, workspace_credits_all, workspace_credits_total, is_coins }) => {
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const [isHovered, setIsHovered] = useState(false);

  const user_credits = workspace_credits_all.filter(transaction => transaction.user_id_creator === user.user_id);
  const user_total = user_credits.reduce((acc, transaction) => acc + transaction.value, 0);
  const percent = workspace_credits_total ? ((user_total / workspace_credits_total) * 100).toFixed(1) : '0';

  const displayValue = is_coins ? `${isHovered ? format_number_with_spaces(user_total) : format_compact_number(user_total)}` : `${percent}%`;

  return (
    <span
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`${md('min-w-[40px] text-[12px]', 'min-w-[100px] h-[50px]')} flex items-center justify-center ${
        user.user_id == current_workspace_user.user_id ? 'border-r border-dashed border-component-item' : ''
      }`}
    >
      <span className={`${user_total == 0 ? 'opacity-50' : ''}`}>{displayValue}</span>
    </span>
  );
};
